import { useState } from 'react'
import { NavLink, Outlet, useNavigate } from 'react-router-dom'
import {
  LayoutDashboard, Briefcase, Newspaper, Handshake, Quote, Sparkles, Mail, LogOut, Menu, X,
} from 'lucide-react'

const links = [
  { to: '/admin', label: 'Dashboard', icon: LayoutDashboard, end: true },
  { to: '/admin/portfolio', label: 'Portfolio', icon: Briefcase },
  { to: '/admin/blog', label: 'Blog / News', icon: Newspaper },
  { to: '/admin/partners', label: 'Partners', icon: Handshake },
  { to: '/admin/testimonials', label: 'Testimonials', icon: Quote },
  { to: '/admin/faqs', label: 'AI Q&A', icon: Sparkles },
  { to: '/admin/messages', label: 'Messages', icon: Mail },
]

export default function AdminLayout() {
  const navigate = useNavigate()
  const [open, setOpen] = useState(false)
  const admin = JSON.parse(localStorage.getItem('ft_admin') || '{}')

  const logout = () => {
    localStorage.removeItem('ft_token')
    localStorage.removeItem('ft_admin')
    navigate('/admin/login')
  }

  const Nav = () => (
    <nav className="space-y-1 flex-1">
      {links.map((link) => {
        const Icon = link.icon
        return (
          <NavLink
            key={link.to}
            to={link.to}
            end={link.end}
            onClick={() => setOpen(false)}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm transition ${
                isActive
                  ? 'bg-gradient-to-r from-cyan-400 to-indigo-500 text-white shadow-lg shadow-cyan-500/20'
                  : 'text-sky-100/80 hover:bg-white/10'
              }`
            }
          >
            <Icon className="w-4 h-4" />
            {link.label}
          </NavLink>
        )
      })}
    </nav>
  )

  return (
    <div className="admin-shell">
      <div className="flex min-h-screen">
        <aside className="w-64 p-5 hidden md:flex flex-col admin-glass m-4 rounded-3xl">
          <div className="mb-8">
            <p className="text-xs uppercase tracking-[0.3em] text-cyan-300">Fortino Tech</p>
            <h2 className="text-xl font-bold">Admin Studio</h2>
          </div>
          <Nav />
          <button onClick={logout} className="flex items-center gap-2 text-sm text-sky-100/70 hover:text-white mt-6">
            <LogOut className="w-4 h-4" /> Sign out
          </button>
        </aside>

        <div className="flex-1 min-w-0">
          <header className="px-4 sm:px-6 py-4 flex justify-between items-center">
            <div className="flex items-center gap-3">
              <button className="md:hidden admin-glass p-2 rounded-xl" onClick={() => setOpen(true)}>
                <Menu className="w-5 h-5" />
              </button>
              <p className="text-sm text-sky-100/70">Signed in as {admin.email || 'admin'}</p>
            </div>
            <a href="/" className="text-sm text-cyan-300 hover:text-white">View website</a>
          </header>
          <div className="p-4 sm:p-6">
            <Outlet />
          </div>
        </div>
      </div>

      {open && (
        <div className="fixed inset-0 z-50 md:hidden">
          <div className="absolute inset-0 bg-black/50" onClick={() => setOpen(false)} />
          <aside className="absolute left-0 top-0 h-full w-72 admin-glass p-5 flex flex-col">
            <div className="flex justify-between items-center mb-6">
              <h2 className="font-bold">Admin Studio</h2>
              <button onClick={() => setOpen(false)}><X /></button>
            </div>
            <Nav />
            <button onClick={logout} className="flex items-center gap-2 text-sm mt-6">
              <LogOut className="w-4 h-4" /> Sign out
            </button>
          </aside>
        </div>
      )}
    </div>
  )
}
